import React from 'react';
import RequestsTableSC from './requests-table.styled';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { LS_ACCESS_TOKEN } from '../../../constants';
import { EmptySC } from '../investor-mailbox-content.styled';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../../redux/action';
import { Pagination } from '../../ui';
import useInlinePagination from '../../../utils/hooks/useInlinePagination';
import InlineLoading from '../../ui/inline-loading';

const RequestsTable = ({ requests, getMailboxRequests, loading }) => {
  React.useEffect(() => {
    getMailboxRequests();
  }, [getMailboxRequests]);

  const {
    slicedData,
    paginationConfig,
    onChange: handlePaginationChange,
    onPageSizeChange,
  } = useInlinePagination(requests);

  const onReqClick = (reqLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${reqLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  if (requests.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          {loading ? (
            <InlineLoading />
          ) : (
            <SmallText className="black-transparent bold">
              <FormattedMessage
                id="mailbox_requests_empty"
                defaultMessage={dlt['mailbox_requests_empty']}
              />
            </SmallText>
          )}
        </div>
      </EmptySC>
    );
  }

  return (
    <RequestsTableSC>
      {slicedData.map((req) => {
        return (
          <div key={req.id} className="req-wrap">
            <button onClick={() => onReqClick(req.document.url)}>
              <span className="req-icon">
                <FileIcon />
              </span>
              <div className="req-info-wrap">
                <span className="req-name">
                  <BodyText>
                    <FormattedMessage
                      id={`mailbox_requests_${req.type}`}
                      defaultMessage={dlt[`mailbox_requests_${req.type}`]}
                    />
                  </BodyText>
                </span>
                <span className="req-date">
                  <BodyText className="black-transparent">
                    <Moment format="DD. MMMM YYYY">{req.created_at}</Moment>
                  </BodyText>
                  <BodyText className="black-transparent">
                    <Moment format="HH:mm">{req.created_at}</Moment>
                  </BodyText>
                </span>
              </div>
            </button>
          </div>
        );
      })}
      {requests.length > 0 && (
        <div className="pagination-wrap">
          <Pagination
            pagination={paginationConfig}
            onChange={handlePaginationChange}
            onPageSizeChange={onPageSizeChange}
          />
        </div>
      )}
    </RequestsTableSC>
  );
};

const mapStateToProps = (state) => {
  return {
    requests: state.mailbox.personal_requests,
    loading: state.mailbox.requestsLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getMailboxRequests: ActionCreators.getMailboxRequests,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestsTable);
